document.addEventListener('DOMContentLoaded', function () {
  const slideshows = document.querySelectorAll('.slideshow-wrapper');

  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1
  };

  const loadSlideshow = (slideshow) => {
    // Load full-res images
    slideshow.querySelectorAll('.slideshow__image').forEach(imgDiv => {
      const bg = imgDiv.dataset.bg;
      if (bg) {
        imgDiv.style.backgroundImage = `url('${bg}')`;
      }
    });

    // Initialize slideshow JS here
    const sectionId = slideshow.closest('[data-section-id]').dataset.sectionId;
    if (window.Slideshow) {
      new Slideshow(`#Slideshow-${sectionId}`);
    }

    // Load videos only when visible
    slideshow.querySelectorAll('.slideshow__video').forEach(videoDiv => {
      const videoId = videoDiv.dataset.id;
      if (videoId && !videoDiv.dataset.loaded) {
        // Your existing video init code
        window.initYouTubeVideo(videoDiv, videoId);
        videoDiv.dataset.loaded = true;
      }
    });
  };

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        loadSlideshow(entry.target);
        obs.unobserve(entry.target);
      }
    });
  }, options);

  slideshows.forEach(slideshow => observer.observe(slideshow));
});
